import React, { useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowUpRight, ChevronLeft, ChevronRight } from "lucide-react";
import { services } from "../data/services";

export default function Services() {
  const scrollerRef = useRef(null);
  const navigate = useNavigate();

  const scroll = (dir) => {
    const el = scrollerRef.current;
    if (!el) return;
    const step = el.clientWidth * 0.8;
    el.scrollBy({ left: dir * step, behavior: "smooth" });
  };

  return (
    <section id="services" data-testid="services-section" className="snap-section" style={{ background: "linear-gradient(180deg, #05101f 0%, #071528 100%)" }}>
      <div className="max-w-[1280px] mx-auto px-6 w-full">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-8">
          <div className="max-w-3xl">
            <div className="section-eyebrow">What we deliver</div>
            <h2 className="section-title" data-testid="services-title">Our Services &amp; Solutions</h2>
            <p className="section-subtitle" data-testid="services-subtitle">
              Six specialised practices — click any card to explore capabilities, use cases and the technologies we work with.
            </p>
          </div>
          <div className="flex gap-3 shrink-0 items-center">
            <button
              onClick={() => navigate("/services")}
              className="btn-secondary hidden md:inline-flex"
              style={{ padding: "10px 18px", fontSize: 14 }}
              data-testid="services-view-all"
            >
              View all
            </button>
            <div className="hidden md:flex gap-2">
              <button
                data-testid="services-scroll-prev"
                onClick={() => scroll(-1)}
                className="w-11 h-11 rounded-full border border-white/15 text-white hover:bg-white/5 flex items-center justify-center transition"
                aria-label="Previous"
              >
                <ChevronLeft size={20} />
              </button>
              <button
                data-testid="services-scroll-next"
                onClick={() => scroll(1)}
                className="w-11 h-11 rounded-full border border-white/15 text-white hover:bg-white/5 flex items-center justify-center transition"
                aria-label="Next"
              >
                <ChevronRight size={20} />
              </button>
            </div>
          </div>
        </div>

        <div ref={scrollerRef} className="h-scroll" data-testid="services-scroller">
          {services.map((s, i) => (
            <Link
              key={s.slug}
              to={`/services/${s.slug}`}
              data-testid={`service-card-${i}`}
              className="glass-card p-4 flex flex-col group no-underline"
            >
              <div className="img-wrap aspect-[16/10] mb-4">
                <img src={s.image} alt={s.title} loading="lazy" />
                <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, transparent 50%, rgba(5,16,31,0.85) 100%)" }} />
              </div>
              <h3 className="text-white text-lg font-semibold mb-2 px-1.5" style={{ fontFamily: "Sora, sans-serif" }}>{s.title}</h3>
              <p className="text-[#a6b3c8] text-[13.5px] leading-relaxed px-1.5 mb-4 flex-1">{s.short}</p>
              <div className="px-1.5 pb-1">
                <span className="inline-flex items-center gap-2 text-[#7fa5e6] text-sm font-medium group-hover:text-white transition-colors" style={{ fontFamily: "Sora, sans-serif" }}>
                  Learn more <ArrowUpRight size={16} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </span>
              </div>
            </Link>
          ))}
        </div>

        <p className="text-[#6b7896] text-xs mt-4 md:hidden">Swipe to explore →</p>
      </div>
    </section>
  );
}
